/**
 * Os e-mails de uma pessoa na ficha do painel (spec 001, 4.7): cada endereco com os selos (principal, verificado), uma
 * linha de apoio (de onde veio, quem acrescentou) e as acoes que cabem nele (corrigir, tornar principal, remover).
 * E o bloco de conferencia de um endereco digitado: errar letra aqui deixa o cliente sem acesso, entao o texto aparece
 * grande, em mono, pra ser lido letra por letra. Nao sabe regra nem marca: quem decide o que da pra fazer e o app, com o
 * que o backend mandou.
 */
import type { ReactNode } from "react";

export type EmailDaLista = {
  chave: string;
  email: string;
  /** Os selos do endereco (principal, verificado). */
  selos?: ReactNode;
  /** Uma linha de apoio: de onde veio, quem acrescentou e quando. */
  detalhe?: ReactNode;
  acoes?: ReactNode;
  /** O endereco que e o de acesso hoje fica com a barra de acento. */
  principal?: boolean;
};

export function ListaDeEmails({ itens, rotulo, vazio = "Nenhum e-mail por aqui." }: { itens: EmailDaLista[]; rotulo: string; vazio?: ReactNode }) {
  if (!itens.length) return <p className="mtc-texto-2" style={{ margin: 0, fontSize: "var(--t-sm)" }}>{vazio}</p>;
  return (
    <ul className="mtc-emails" aria-label={rotulo}>
      {itens.map((e) => (
        <li key={e.chave} className="mtc-email" data-principal={e.principal || undefined}>
          <div className="mtc-email__textos">
            <span className="mtc-email__endereco mtc-mono">{e.email}</span>
            {e.selos && <span className="mtc-email__selos">{e.selos}</span>}
            {e.detalhe && <span className="mtc-email__detalhe">{e.detalhe}</span>}
          </div>
          {e.acoes && <div className="mtc-email__acoes">{e.acoes}</div>}
        </li>
      ))}
    </ul>
  );
}

/**
 * O e-mail digitado, grande e em mono, pra conferir letra por letra antes de gravar. `tom`: `conferir` (azul) quando as
 * duas digitacoes batem: nao diz que o e-mail existe, so que e o que foi digitado; `alerta` quando algo pede cuidado.
 */
export function EmailParaConferir({ rotulo, email, tom = "conferir", children }: { rotulo: string; email: string; tom?: "conferir" | "alerta"; children?: ReactNode }) {
  return (
    <div className={`mtc-email-conferido mtc-email-conferido--${tom}`} role="group" aria-label={rotulo}>
      <span className="mtc-email-conferido__rotulo">{rotulo}</span>
      <span className="mtc-email-conferido__valor mtc-mono">{email}</span>
      {children && <span className="mtc-email-conferido__apoio">{children}</span>}
    </div>
  );
}
